import React from 'react';
import { useSelector } from 'react-redux';

const SpeedDetails = () => {
    const robotDetalis = useSelector((state) => state.robotDetails)
    const modalIsOpen = useSelector((state) => state.testDriveDetails.modalIsOpen);
    const speed = robotDetalis?.SpeedMeasure * 20;

    const customStyles = {
        height: `${speed > 40 ? 100 : speed}%`,
        background: `${speed > 40 ? 'linear-gradient(to top,red 0%,red 20%,#25BD66 20%,#25BD66 100%)' : '#25BD66'}`
    }

    return (
        <div className="speed-indicator" style={{ display: modalIsOpen ? 'none' : 'flex' }}>
            <div className='speed-indicator-container'>
                <div className='speed-indicator' style={customStyles}></div>
            </div>
            <div className='kmh-container'>
                <p className='kmh-letter'>KMH</p>
                <div className='kmh-number-container'>
                    <p id='speedMeasure' className='kmh-nummer-letter'></p>
                </div>
            </div>
            <div className="speedCount-lettter">{robotDetalis?.SpeedMeasure}</div>
        </div>
    )
}

export default SpeedDetails;
